import alt from '../alt';

import CerseActions from '../actions/CerseActions';

function intersection(items,store) {
  return store.filter(storeLinha =>
    items.find(item => storeLinha.value === item) !== undefined
  );
}

class CerseStore {
  constructor() {
    this.csvfile = '';
    this.csvArraySeparator = ',';
    this.articles = [];
    this.formsContent = {
      methods: [],
      phases: [],
      objectives: [],
      maturities: [],
      articlesProcessed: [],
      rowsSelected: []
    };

    this.methods = [
      {value:'1', label:'CSR', description:"Case Study Research"},
      {value:'2', label:'AcR', description:"Action Research"},
      {value:'3', label:'DSc', description:"Design Science"},
      {value:'4', label:'Intvw', description:"Interviews"},
      {value:'4a', label:'FG', description:"Focus Group"},
      {value:'5', label:'Obs', description:"Observation"},
      {value:'5a', label:'Ethn', description:"Ethnography"},
      {value:'5b', label:'TAM', description:"Think-Aloud Method"},
      {value:'6', label:'ArC', description:"Archival Research"},
      {value:'6a', label:'PmR', description:"Postmortem Review"},
      {value:'7', label:'SLR', description:"Systematic Literature Review"},
      {value:'8', label:'SMS', description:"Systematic Mapping Study"},
      {value:'9', label:'SR', description:"Survey-based Research"},
      {value:'9a', label:'Delphi', description:"Delphi Method"},
      {value:'10', label:'Exp', description:"Experiment"},
      {value:'10a', label:'QExp', description:"Quasi-Experiment"},
      {value:'11', label:'Sim', description:"Simulation"},
      {value:'12', label:'TA', description:"Thematic Analysis"},
      {value:'12a', label:'CA', description:"Content Analysis"},
      {value:'13', label:'GT', description:"Grounded Theory"},
      {value:'14', label:'Herm', description:"Hermeneutics"},
      {value:'15', label:'SA', description:"Statistical Analysis"},
      {value:'15a', label:'MA', description:"Meta-Analysis"},
      {value:'16', label:'ER', description:"Overall empirical research"}
    ];
    this.phases = [
      {value:'1', label:'P', description:"Planning/Design"},
      {value:'2', label:'E', description:"Execution"},
      {value:'3', label:'A', description:"Analysis"},
      {value:'4', label:'R', description:"Reporting"}
    ];
    this.objectives = [
      {value:'1', label:'GL', description:"Guideline"},
      {value:'4', label:'GL-Rep', description:"Guideline for replication", hide:true},
      {value:'5', label:'GL-Eval', description:"Guideline evaluation", hide:true},
      {value:'6', label:'GL-Tch', description:"Guideline for teaching", hide:true},
      {value:'2', label:'Assess', description:"Assessment instrument"},
      {value:'3', label:'KOS', description:"Knowledge organization system"}
    ];
    this.maturity = [
      {value:'1', label:'1', description:"1. Problem investigation"},
      {value:'2', label:'2', description:"2. Solution design"},
      {value:'3', label:'3', description:"3. Solution validation"},
      {value:'4', label:'4', description:"4. Solution selection"},
      {value:'5', label:'5', description:"5. Solution implementation"},
      {value:'6', label:'6', description:"6. Implementation evaluation"}
    ];

    this.bindListeners({
      handleCsvLoaded: CerseActions.CSV_LOADED,
      saveFormsContent : CerseActions.SAVE_FORMS_CONTENT,
    });
  }

  saveFormsContent(newContent) {
    this.setState({
      formsContent: newContent
    })
  }

  handleCsvLoaded(info) {
    //Formatar informações
    info.articles.forEach(linha => {
      linha.methodsFm = intersection(
        (linha.methods||'').split(this.csvArraySeparator),
        this.methods);

      linha.phasesFm = intersection(
        (linha.phases||'').split(this.csvArraySeparator),
        this.phases);

      linha.objectiveFm = intersection(
        (linha.objective||'').split(this.csvArraySeparator),
        this.objectives);

      linha.maturityFm = intersection(
        (linha.maturity||'').split(this.csvArraySeparator),
        this.maturity)
        .map(linha => linha.label)
        .join(", ");
    });

    this.setState({
      articles: info.articles,
      csvstring: info.csvstring
    });
  }
}


export default alt.createStore(CerseStore, "Cerse");



// WEBPACK FOOTER //
// ./src/stores/CerseStore.js